// extracted by mini-css-extract-plugin
module.exports = {"contentTooltip":"mailContent_contentTooltip__ytb3H","content":"mailContent_content__3M12P"};